// src/utils/apiBase.js
// ---------------------------------------------------------------------------
// Where the API lives. One answer, in one place.
//
// EMPTY STRING IS THE RIGHT DEFAULT, NOT A PLACEHOLDER.
// An empty base makes every call RELATIVE — `/api/projects` rather than
// `https://something/api/projects` — which means the request goes to whatever
// origin the app is already served from. In development that is the CRA dev
// server, and package.json's "proxy": "http://localhost:5000" forwards it to the
// backend server-side. The browser therefore makes no cross-origin request at
// all: no CORS, no preflight, and no second forwarded port that has to be
// public and stay public.
//
// That last part is what broke. Thirteen files each hardcoded this Codespace's
// port-5000 URL, so every API call left the browser, crossed GitHub's port
// forwarder and came back 404 — while the same routes answered fine on
// localhost. A hostname baked into thirteen files is also a hostname baked into
// the production bundle, which is why the built app can only ever talk to one
// person's development machine.
//
// Set REACT_APP_API_BASE at build time when the API is genuinely elsewhere.
// ---------------------------------------------------------------------------

export const API_BASE = process.env.REACT_APP_API_BASE || '';

export default API_BASE;
